<template>

    <div>
        <div class="column-item" v-for="(item, i) in items" :key="`${item}-${i}`">
            <div class="description">{{item.label}}</div>
            <div class="value">{{item.value}}</div>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'statistics-column',
    props: {
        items: {
            type: Array,
            required: true
        }
    }
}
</script>